<h2>
  <b>{{ header }}</b>
  <div class="right-container">
    <iv-dynamic-outlet
      dynamicComponent="{{ userCountry }}-joint-agent"
      [inputData]="{
        transaction: transaction,
        disabled: disabled,
      }"
      (saveData)="saveTransactionFn($event)">
    </iv-dynamic-outlet>
    <iv-upload-list-button
      class="upload-button"
      [uploadObject]="uploadFile(transaction.id)"
      (loadList)="loadTransactionEmitter.emit()"
      buttonText="Upload Deal File Documents"
      [transactionStatus]="transaction.status_name">
    </iv-upload-list-button>
    <iv-upload-list
      [fileList]="transaction.fee_contracts"
      [hideDeleteBtn]="hideDeleteDocumentsBtn"
      (deleteFile)="deleteFile($event)"
      (downloadFile)="download($event)"
      headerText="Uploaded Deal File Documents"
      [transactionStatus]="transaction.status_name">
    </iv-upload-list>
  </div>
</h2>

<div class="boxed-content">
  <header i18n>Please answer each question below</header>
  <div class="boxed-content__container">
    <form [formGroup]="dealFileChecklistForm" novalidate>
      <div *ngFor="let question of questionsArray">
        <h4>
          {{ getTranslation(question.identifier) }}
          <span class="required">*</span>
          <a *ngIf="question.link && question.identifier !== 'go_related_client'
            &&  question.identifier !== 'japan_government_entity' && question.identifier !== 'india_rei_standard_agency_agreement'"
            href="{{question.link.url}}" target="_blank" rel="noopener"
            [innerHTML]="getTranslation(question.link.identifier)">
          </a>
        </h4>
        <div class="radio-container" fxLayout="row wrap" *ngIf="question.options">
          <mat-radio-group fxFlex="40" id="{{question.identifier}}"
            formControlName="{{question.identifier}}" matInput>
            <mat-radio-button
              *ngFor="let option of question.options"
              id="{{question.identifier}}_{{option.identifier}}"
              [value]="option.value"
              color="primary">
              {{ getTranslation(option.identifier) }}
            </mat-radio-button>
          </mat-radio-group>
          <mat-form-field
            *ngIf="toggleNoteField(dealFileChecklistForm.get(question.identifier).value, question.identifier)
              && question.identifier !== 'go_related_client'
              && question.identifier !== 'japan_government_entity'
              && question.identifier !== 'revenue_recognition_policy'
              && question.identifier !== 'india_rei_standard_agency_agreement'
              && question.identifier !== 'mortgage_valuation_msa'"
            fxFlex="60" floatLabel="never">
            <input id="{{question.identifier}}_note"
              type="text"
              matInput
              formControlName="{{question.identifier}}_note"
              placeholder="please enter detail note here" i18n-placeholder
              maxlength="254"/>
          </mat-form-field>
          <div class="document" *ngIf="toggleNoteField(dealFileChecklistForm.get(question.identifier).value, question.identifier)
              && (question.identifier === 'go_related_client'|| question.identifier === 'japan_government_entity')">
            <a href="{{question.link.url}}" [innerHTML]="getTranslation(question.link.identifier)"></a>
          </div>
          <!-- for label to show besides radio button -->
          <div *ngIf="question.identifier === 'india_rei_standard_agency_agreement'">
            <span>{{getTranslation(question?.info?.identifier)}}</span>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
